// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"b5a99fbb","699":"48c4e5f9","788":"b2e9981e","805":"bd008b11"}[chunkId] + ".chunk.js";
};